import { isBadManifest, type DeliveryBundle, type DeliveryState } from './deliveryState'

/**
 * How many failed downloads of one remote bundle in a row pause it until
 * the server publishes a different manifest (spec §3.4).
 */
export const DOWNLOAD_FAILURE_LIMIT = 3

/**
 * Whether to download a remote bundle: supported format, never marked bad,
 * not failing again and again, and newer than everything the client could
 * already use. Port of `delivery.Offer`.
 */
export function offer(
  state: DeliveryState,
  remote: DeliveryBundle,
  supportedFormat: number,
): boolean {
  if (remote.format > supportedFormat || isBadManifest(state, remote.manifest)) return false
  if (remote.manifest === state.failedManifest && state.failedCount >= DOWNLOAD_FAILURE_LIMIT) {
    return false
  }
  let newest = state.bundled.sequence
  for (const b of [state.active, state.pending]) {
    if (b !== undefined && b.sequence > newest) newest = b.sequence
  }
  return remote.sequence > newest
}
